export const LOADING_INCIDENTS = 'INCIDENTS::LOADING_INCIDENTS'
export const RECEIVE_INCIDENTS = 'INCIDENTS::RECEIVE_INCIDENTS'
export const ERROR_INCIDENTS = 'INCIDENTS::ERROR_INCIDENTS'

export const TABLE_PROPS = 'INCIDENTS::TABLE_PROPS'
